var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-modal',_vm._g(_vm._b({attrs:{"name":"project-influencer-edit","toptitle":"Influencer Kooperation bearbeiten","title":_vm.projectInfluencer.influencer.name,"width":400}},'base-modal',_vm.$attrs,false),_vm.$listeners),[_c('project-influencer-form',{attrs:{"projectInfluencer":_vm.projectInfluencer,"type":"edit"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }